import { render } from "./Alerts.vue?vue&type=template&id=d113c518"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\POS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__